import DataTableItem from "ui/DataTableResponsive/DataTableItem"
import PropTypes from "prop-types";

export const BookingListing = ({data, onItemClick}) => {
  return (
    <div>
      {data.map((listData) => (
        <DataTableItem
          key={listData.id}
          data={listData}
          onClick={() => onItemClick?.(listData)}
        />
      ))}
    </div>
  )
}

BookingListing.propTypes = {
  data: PropTypes.array.isRequired,
  onItemClick: PropTypes.func
};
